import { Action } from '@ngrx/store';
import { DomainAuthenticator, MultipleAuthenticator } from '../../core/authentication-contracts';

export enum EAuthenticationActions {
  GetMetadata = '[Authentication metadata] Get authentication metadata to Authentication',
  GetMetadataSuccess = '[Authentication metadata] Get authentication metadata to Authentication success',
  GetMaintenanceWindowStatus = '[Maintence Windows Status] Get maintenance windows status',
  GetMaintenanceWindowStatusSuccess = '[Maintence Windows Status] Get maintenance windows status success',
  GetAuthenticationData = '[Authentication data] Get authentication',
  GetAuthenticationDataSuccess = '[Authentication data] Get authentication success',
  SetCurrentMethod = '[Authentication data] set current authentication method',
  SetMultipleViewMode = '[Authentication Multiple] set view mode authentication multiple',
  SetCurrentAuthenticator = '[Multiple authentication] set selected authenticator',
  GetMultipleOptions = '[Authentication Multiple options] Get Multiple options to edit',
  GetMultipleOptionsSuccess = '[Authentication Multiple options] Get Multiple options to edit success',
  AddNewMultipleAuthenticator = '[Multiple authentication] Add new authenticator',
  UpdateMultipleAuthenticator = '[Multiple authentication] Update authenticator data',
  SaveAuthenticationData = '[Authentication data] Save Authentication data',
  UpdateAuthenticationDataSuccess = '[Authentication data] Update Authentication data success',
  UpdateAuthenticationDataError = '[Authentication data] Update Authentication data error',
  UpdateAuthenticatorOption = '[Multiple authentication] Update current authenticator option',
  DeleteAuthenticators = '[Multiple authentication] Delete authenticators',
  CleanMultipleAuthState = '[Multiple authentication] Clean all State',
  UpdateDomainList ='[Multiple authentication] update damain list of authenticator on local.',
  GetMultipleOptionsDefaultValues = '[Authentication Multiple options default values] Get Multiple options default values',
  GetMultipleOptionsDefaultValuesSuccess = '[Authentication Multiple options default values] Get Multiple options default values success',
  GetAuthenticationIsValid = '[Authentication] Get is valid authentication',
  GetAuthenticationIsValidSuccess = '[Authentication] Get is valid authentication success',
}

export class GetMetadata implements Action {
  public readonly type = EAuthenticationActions.GetMetadata;
}

export class GetMetadataSuccess implements Action {
  public readonly type = EAuthenticationActions.GetMetadataSuccess;
  constructor(public payload: { [key: string]: { options: any } }) {}
}

export class GetMaintenanceWindowStatus implements Action {
  public readonly type = EAuthenticationActions.GetMaintenanceWindowStatus;
}

export class GetMaintenanceWindowStatusSuccess implements Action {
  public readonly type =
    EAuthenticationActions.GetMaintenanceWindowStatusSuccess;
  constructor(public payload: boolean) {}
}

export class GetAuthenticationIsValid implements Action {
  public readonly type = EAuthenticationActions.GetAuthenticationIsValid;
}

export class GetAuthenticationIsValidSuccess implements Action {
  public readonly type =
    EAuthenticationActions.GetAuthenticationIsValidSuccess;
  constructor(public payload: boolean) {}
}

export class GetAuthenticationData implements Action {
  public readonly type = EAuthenticationActions.GetAuthenticationData;
}

export class GetAuthenticationDataSuccess implements Action {
  public readonly type = EAuthenticationActions.GetAuthenticationDataSuccess;
  constructor(public payload: any) {}
}

export class SetCurrentMethod implements Action {
  public readonly type = EAuthenticationActions.SetCurrentMethod;
  constructor(public payload: {type?: string, subtype?: string}) {}
}

export class SetCurrentAuthenticator implements Action {
  public readonly type = EAuthenticationActions.SetCurrentAuthenticator;
  constructor(public payload: MultipleAuthenticator) {}
}

export class SetMultipleViewMode implements Action {
  public readonly type = EAuthenticationActions.SetMultipleViewMode;
  constructor(public payload: number) {}
}

export class GetMultipleOptions implements Action {
  public readonly type = EAuthenticationActions.GetMultipleOptions;
}

export class GetMultipleOptionsSuccess implements Action {
  public readonly type = EAuthenticationActions.GetMultipleOptionsSuccess;
  constructor(public payload: Array<any>) {}
}

export class AddNewMultipleAuthenticator implements Action {
  public readonly type = EAuthenticationActions.AddNewMultipleAuthenticator;
  constructor(public payload: any) { }
}

export class UpdateMultipleAuthenticator implements Action {
  public readonly type = EAuthenticationActions.UpdateMultipleAuthenticator;
  constructor(public payload: any) { }
}

export class UpdateAuthenticatorOption implements Action {
  public readonly type = EAuthenticationActions.UpdateAuthenticatorOption;
  constructor(public payload: any) { }
}

export class SaveAuthenticationData implements Action {
  public readonly type = EAuthenticationActions.SaveAuthenticationData;
  constructor() { }
}

export class UpdateAuthenticationDataSuccess implements Action {
  public readonly type = EAuthenticationActions.UpdateAuthenticationDataSuccess;
  constructor() { }
}

export class UpdateAuthenticationDataError implements Action {
  public readonly type = EAuthenticationActions.UpdateAuthenticationDataError;
  constructor() { }
}

export class DeleteAuthenticators implements Action {
  public readonly type = EAuthenticationActions.DeleteAuthenticators;
  constructor(public payload: any) { }
}

export class CleanMultipleAuthState implements Action {
  public readonly type = EAuthenticationActions.CleanMultipleAuthState;
}

export class UpdateDomainList implements Action {
  public readonly type = EAuthenticationActions.UpdateDomainList;
  constructor(public payload: DomainAuthenticator[]){};
}

export class GetMultipleOptionsDefaultValues implements Action {
  public readonly type = EAuthenticationActions.GetMultipleOptionsDefaultValues;
}

export class GetMultipleOptionsDefaultValuesSuccess implements Action {
  public readonly type = EAuthenticationActions.GetMultipleOptionsDefaultValuesSuccess;
  constructor(public payload: any) {}
}

export type AuthenticationActions =
  | GetMetadata
  | GetMetadataSuccess
  | GetMaintenanceWindowStatus
  | GetMaintenanceWindowStatusSuccess
  | GetAuthenticationData
  | GetAuthenticationDataSuccess
  | SetCurrentMethod
  | SetCurrentAuthenticator
  | SetMultipleViewMode
  | GetMultipleOptions
  | GetMultipleOptionsSuccess
  | AddNewMultipleAuthenticator
  | UpdateMultipleAuthenticator
  | SaveAuthenticationData
  | UpdateAuthenticationDataSuccess
  | UpdateAuthenticationDataError
  | UpdateAuthenticatorOption
  | DeleteAuthenticators
  | CleanMultipleAuthState
  | UpdateDomainList
  | GetMultipleOptionsDefaultValues
  | GetMultipleOptionsDefaultValuesSuccess
  | GetAuthenticationIsValid
  | GetAuthenticationIsValidSuccess;
